module.exports = __webpack_public_path__ + "hat-blueprint-chocolate-ice-cream.4440f0b48b7ebf541daa.svg";


//////////////////
// WEBPACK FOOTER
// /vercel/workpath0/src/assets/img/hat-blueprint-chocolate-ice-cream.svg
// module id = ../../../../../src/assets/img/hat-blueprint-chocolate-ice-cream.svg
// module chunks = main